// Mirrors layouts/_flash_notifications_fixed.slim's shape (a bottom-right danger sl-alert with a
// header + message) -- built here rather than fetched, for a client-driven event with nothing
// server-side to re-render a turbo_stream from.
export const flashDangerAlert = (title, message) => {
  const flash = document.getElementById("flash");
  if (!flash) return;

  // Reuses an existing wrapper (from a prior call, or from the server-rendered flash this shares
  // an id with) rather than creating a second one -- two "fixed, right-6, bottom-6" boxes pin to
  // the identical corner and paint over each other instead of stacking, the way sibling sl-alerts
  // inside one such box do.
  const wrapper = flash.querySelector(":scope > .fixed") || (() => {
    const div = document.createElement("div");
    div.className = "fixed z-20 right-6 bottom-6";
    flash.appendChild(div);
    return div;
  })();

  const alert = document.createElement("sl-alert");
  alert.setAttribute("variant", "danger");
  alert.setAttribute("open", "true");
  alert.setAttribute("closable", "true");
  alert.innerHTML = "<sl-icon slot=\"icon\" library=\"fa\" name=\"fas-circle-exclamation\"></sl-icon>" +
    "<div slot=\"header\"></div>";
  alert.querySelector("[slot='header']").append(document.createTextNode(title));
  alert.append(document.createTextNode(message));

  wrapper.appendChild(alert);
};
